<div class="task-modal-group">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-2">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="closeModal()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal" #top>
          Proximas Visitas
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- body content -->
  <div *ngIf="!loading && readOnly">

    <div class="row my-3">

      <div class="col-12 mb-2">
        <h5 class="m-0 text-purple-manax text-capitalize title-modal">
          {{task.client?.firstname}}{{task.client?.lastname ? ' ' + task.client?.lastname : ''}}
          <ng-container *ngIf="task?.title">
            /&nbsp;{{task.title}}
          </ng-container>
        </h5>
      </div>

      <div class="col-12">
        <div class="row">
          <table class="table table-hover m-0 align-top">
            <tbody>

              <tr (click)="openEditTaskModal(task)" *ngIf="!haveRecurrence">
                <td>
                  {{startDateTime}}
                </td>
                <td>
                  <span class="status-pill status-label"
                    [ngStyle]="{'background-color': taskStatusColors[f['status'].value] || taskStatusColors.DEFAULT}"
                    *ngIf="action !== 'Crear'">
                    {{taskStatuses[f['status'].value]}}
                  </span>
                </td>
                <td class="text-right">
                  <div *ngIf="task?.workers && task?.workers?.length === 0">
                    Sin Trabajador Asignado
                  </div>
                  <div *ngIf="task?.workers && filteredWorkers.length > 0">
                    Asignado a
                    <span *ngFor="let worker of filteredWorkers; let isLast=last">
                      &nbsp;{{worker?.firstname}} {{worker?.lastname ? worker?.lastname : ""}}{{!isLast ? ', ' : ''}}
                    </span>
                  </div>
                </td>
              </tr>


              <tr *ngFor="let appo of nextAppointments" class='cursor-pointer' (click)="openEditTaskModal(appo?.task)">
                <td>
                  {{appo?.startDateTime}}
                </td>
                <td>
                  <span class="status-pill status-label"
                    [ngStyle]="{'background-color': taskStatusColors[appo?.task?.status] || taskStatusColors.DEFAULT}"
                    *ngIf="action !== 'Crear'">
                    {{taskStatuses[appo?.task?.status]}}
                  </span>
                </td>
                <td class="text-right">
                  <div *ngIf="!hasActiveWorkers(appo?.workers)">
                    Sin Trabajador Asignado
                  </div>
                  <div *ngIf="hasActiveWorkers(appo?.workers)">
                    Asignado a
                    <span *ngFor="let worker of getActiveWorkers(appo?.workers); let isLast=last">
                      &nbsp;{{worker?.firstname}} {{worker?.lastname}}{{!isLast ? ', ' : ''}}
                    </span>
                  </div>
                </td>
              </tr>



              <tr *ngIf="thereAreMore && !loading" (click)='loadMore()' class="cursor-pointer">
                <td colspan="10">
                  <button class="btn btn-link text-purple-manax text-capitalize p-0">
                    + Cargar mas
                  </button>
                </td>
              </tr>


              <tr *ngIf="loading">
                <td colspan="10" class="text-center">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>